import { useTranslation } from "react-i18next";
import {
  Card,
  Col,
  Form,
  FormInstance,
  Layout,
  Row,
  Spin,
  TableColumnsType,
  TableProps,
  Typography,
} from "antd";
import PageHeader from "../../../../../components/page-header/PageHeader";
import FilterTable from "./filter-table/FilterTable";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import FormFilter from "./filter-group/FormFilter";
import TableData from "../../../../../components/table-data/TableData";
import { DataType } from "./constants/data";
import { useNavigate, useParams } from "react-router-dom";
import { getQuizById } from "../../../../../service/course-construct";
import {
  getQuizInUseInfo,
  getVersionsOfQuiz,
} from "../../../../../service/quiz-preview";
import { QuestionTypeEnum } from "../../../../../constants";
import ChooseText from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/choose-text/ChooseText";
import ChooseImage from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/choose-image";
import ChooseVideo from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/choose-video";
import TrueOrFalse from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/true-or-false";
import ChooseMultiText from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/choose-multi-text";
import ChooseMultiImage from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/choose-multi-image";
import ChooseMultiVideo from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/choose-multi-video";
import Connect from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/connect";
import ShortText from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/short-text";
import FileUpload from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/file-upload";
import Video from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/video";
import Mp3 from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/mp3";
import DropDown from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/drop-down";
import FillText from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/fill-text/FillText";
import Calculated from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/caculated";
import Numerical from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/numerical";
import Essay from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/essay";
import LongText from "../../../../../components/course-content/learning-course/components/quiz-screen/quiz/long-text";
import { useForm } from "antd/es/form/Form";
import { CloseOutlined } from "@ant-design/icons";
import "./list-of-uses.scss";
import { routesConfig } from "../../../../../config/routes";

const ListOfUses = () => {
  const { t } = useTranslation();
  const params = new URLSearchParams(location.search);
  const { id } = useParams();
  const name = params.get("name");
  const quizId = params.get("quizId");
  const version = params.get("version");

  const [form] = useForm();
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState<number>(10);
  const [listOfUses, setListOfUses] = useState<any>([]);
  const [quizDetail, setQuizDetail] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [listVersions, setListVersions] = useState<any>([]);
  const [dataQuizUsed, setDataQuizUsed] = useState<any>([]);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [isOpenCard, setIsOpenCard] = useState<boolean>(false);
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [isLoadingQuizDetail, setIsLoadingQuizDetail] = useState<boolean>(true);

  const [filterData, setFilterData] = useState<any>({
    version: null,
    publishStatus: null,
  });

  // data columns
  const dataColumns: TableColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 5,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Mã khóa học", "Mã khóa học"),
      dataIndex: "courseCode",
      key: "courseCode",
      width: 10,
    },
    {
      title: t("Tên khóa học", "Tên khóa học"),
      dataIndex: "courseName",
      key: "courseName",
      width: 18,
    },
    {
      title: t("Tên bài đánh giá", "Tên bài đánh giá"),
      dataIndex: "unitName",
      key: "unitName",
      width: 18,
    },
    {
      title: t("Phiên bản", "Phiên bản"),
      dataIndex: "questionBankVersion",
      key: "questionBankVersion",
      width: 8,
      render: (_: any, record: any) => (
        <Typography.Link
          onClick={() => {
            getQuizDetailById(record.quizId);
            setIsOpenCard(true);
          }}
        >
          {record.questionBankVersion}
        </Typography.Link>
      ),
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "isPublished",
      key: "isPublished",
      width: 10,
      render: (_: any, record: any) => (
        <span>
          {record.isDeleted ? (
            <div className="table-status">
              <div
                className="color-icon"
                style={{ backgroundColor: "#FF4D4F" }}
              ></div>
              {t("Đã xóa", "Đã xóa")}
            </div>
          ) : record.isPublished ? (
            <div className="table-status">
              <div
                className="color-icon"
                style={{ backgroundColor: "#52C41A" }}
              ></div>
              {t("Đã xuất bản", "Đã xuất bản")}
            </div>
          ) : (
            <div className="table-status">
              <div
                className="color-icon"
                style={{ backgroundColor: "#D9D9D9" }}
              ></div>
              {t("Chưa xuất bản", "Chưa xuất bản")}
            </div>
          )}
        </span>
      ),
    },
  ];

  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = () => {
    form.resetFields();
    setFilterData({
      version: null,
      publishStatus: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      fetchData();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    fetchData();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setFilterData({
      ...filterData,
      version: values?.version.map(Number),
      publishStatus: values?.publishStatus,
    });
  };

  // fetchData
  const fetchData = async () => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      quizId: quizId,
      bankId: id,
      versions: isFirstTime ? [Number(version)] : filterData.version,
      isPublished: filterData.publishStatus,
    };
    try {
      const res = await getQuizInUseInfo(dataReq);
      if (res.status === 200) {
        setListOfUses(res.data.data?.content);
        setTotalRecords(res.data.data?.totalElements);
        setLoading(false);
        setIsFirstTime(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // get quiz's versions
  const getVersion = async () => {
    setLoading(true);
    try {
      const res = await getVersionsOfQuiz(Number(quizId));
      if (res.status === 200) {
        const versions = res.data.data?.map((item: any) => ({
          value: item.version,
          label: `Phiên bản ${item.version}`,
          quizId: item.quizId,
        }));

        setListVersions(versions);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // get detail quiz
  const getQuizDetailById = async (quizId: number) => {
    setIsLoadingQuizDetail(true);
    try {
      const res = await getQuizById(quizId);
      if (res.status === 200) {
        setQuizDetail(res.data.body);
        setIsLoadingQuizDetail(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingQuizDetail(false);
    }
  };

  // render question by type
  const renderQuestionByType = (quiz: any) => {
    const data = {
      ...quiz,
      questions:
        quiz?.answers !== undefined
          ? typeof quiz?.answers === "string"
            ? JSON.parse(quiz?.answers)
            : quiz?.answers
          : "",
    };

    switch (quiz?.type) {
      case QuestionTypeEnum.CHOOSE_TEXT:
        return <ChooseText data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_IMAGE:
        return <ChooseImage data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_VIDEO:
        return <ChooseVideo data={data} hiddenIndex/>;
      case QuestionTypeEnum.TRUE_OR_FALSE:
        return <TrueOrFalse data={data} hiddenIndex/>;
      case QuestionTypeEnum.DROP_DOWN:
        return <DropDown data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_MULTI_TEXT:
        return <ChooseMultiText data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_MULTI_IMAGE:
        return <ChooseMultiImage data={data} hiddenIndex/>;
      case QuestionTypeEnum.CHOOSE_MULTI_VIDEO:
        return <ChooseMultiVideo data={data} hiddenIndex/>;
      case QuestionTypeEnum.CONNECT:
        return <Connect data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.SHORT_TEXT:
        return <ShortText data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.LONG_TEXT:
        return <LongText data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.FILE_UPLOAD:
        return <FileUpload data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.VIDEO:
        return <Video data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.MP3:
        return <Mp3 data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.FillText:
        return <FillText data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.CALCULATED:
        return <Calculated data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.CALCULATED_SIMPLE:
        return <Calculated data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.CALCULATED_MULTI:
        return <Calculated data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.NUMERICAL:
        return <Numerical data={data} disabled hiddenIndex/>;
      case QuestionTypeEnum.ESSAY:
        return <Essay data={data} disabled hiddenIndex/>;
      default:
        break;
    }
  };

  // useEffect
  useEffect(() => {
    fetchData();
  }, [pageNumber, pageSize, filterData, statusOrder]);

  useEffect(() => {
    getVersion();
  }, [quizId]);

  useEffect(() => {
    if (isFirstTime) {
      form.setFieldValue("version", [version]);
      setFilterData({
        ...filterData,
        version: [Number(version)],
      });
    }
  }, []);

  useEffect(() => {
    const versionToQuizMap = new Map(
      listVersions.map((ver: any) => [ver.value, ver.quizId])
    );

    const data = listOfUses.map((useItem: any) => ({
      ...useItem,
      quizId: versionToQuizMap.get(useItem.questionBankVersion),
    }));

    setDataQuizUsed(data);
  }, [listOfUses, listVersions]);

  return (
    <Layout className="page-header-group unit-list-page">
      <Form.Provider>
        <div className={`page-header-group--layout`}>
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader
                title={`Ngân hàng câu hỏi/ ${name} / Thống kê lượt sử dụng`}
              />
            </div>
            <FilterTable
              searchValue={searchValue}
              handleSearch={handleSearch}
              handleOpenFilter={handleOpenFilter}
              handleChangeInput={handleChangeInput}
              handleSubmitSearch={handleSubmitSearch}
            />
          </div>
          <FormFilter
            form={form}
            version={version}
            showFilter={showFilter}
            listVersions={listVersions}
            onFinish={handleFinish}
            clearFilter={clearFilter}
          />
        </div>
        <Row className="list-of-uses">
          <Col
            md={{ span: isOpenCard ? 15 : 24 }}
            lg={{ span: isOpenCard ? 15 : 24 }}
            xl={{ span: isOpenCard ? 15 : 24 }}
            xs={{ span: 24 }}
            className={`list-of-uses__table ${isOpenCard ? "view-detail" : ""}`}
          >
            <div className="list-of-uses__table-info">
              <Typography.Title level={4}>
                {t("Bảng thống kê lượt sử dụng", "Bảng thống kê lượt sử dụng")}{" "}
              </Typography.Title>
              <span>{t("Tổng số lượt sử dụng:", "Tổng số lượt sử dụng:")} {totalRecords} </span>
            </div>
            <TableData
              pagination={true}
              pageSize={pageSize}
              dataTable={dataQuizUsed}
              loadingTable={loading}
              pageNumber={pageNumber}
              dataColumns={dataColumns}
              totalRecords={totalRecords}
              setPageSize={setPageSize}
              setPageNumber={setPageNumber}
              handleTableChangeProps={handleTableChange}
              scroll={isOpenCard ? { x: 900, y: 500 } : { x: 1500, y: 600 }}
            />
          </Col>
          {isOpenCard ? (
            <Col
              md={{ span: 9 }}
              lg={{ span: 9 }}
              xl={{ span: 9 }}
              xs={{ span: 24 }}
              className="list-of-uses__card"
            >
              <Card
                className="slide-in"
                title={t("Nội dung câu hỏi", "Nội dung câu hỏi")}
                extra={
                  <a
                    onClick={() => {
                      setQuizDetail({});
                      setIsOpenCard(false);
                    }}
                  >
                    <CloseOutlined />
                  </a>
                }
              >
                {isLoadingQuizDetail ? (
                  <Spin />
                ) : (
                  <div>{renderQuestionByType(quizDetail)}</div>
                )}
              </Card>
            </Col>
          ) : null}
        </Row>
      </Form.Provider>
    </Layout>
  );
};

export default ListOfUses;
